// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#header_text[data-v-2a16852a] {\n  font-size: 1.5rem;\n  text-align: left;\n}\n#header_divider[data-v-2a16852a] {\n  border: 1px solid #8d8d8d;\n}\n.back_clean_btn[data-v-2a16852a] {\n  background-color: transparent !important;\n  min-width: 1rem !important;\n  color: white;\n}\n.newline-format[data-v-2a16852a] {\n  white-space: pre-line;\n}", ""]);
// Exports
module.exports = exports;
